import { Dispatch, SetStateAction } from "react";

import { P3B } from "../base/TextComponents/P3B";
import { cn } from "../ClassName";

interface Props {
  className?: string;
  on: boolean;
  setOn: Dispatch<SetStateAction<boolean>>;
  /** "md" (default) is the 80×36 ON/OFF switch; "sm" is a compact 36×20
   * switch with no text, for dense menus. */
  size?: "sm" | "md";
}

// Full class strings, so Tailwind can see them.
const SIZES = {
  md: {
    track: "tw-h-[36px] tw-w-[80px] tw-rounded-[18px] tw-p-[4px]",
    handle: "tw-h-[28px] tw-w-[28px]",
    onShift: "tw-translate-x-[44px]",
  },
  sm: {
    track: "tw-h-[20px] tw-w-[36px] tw-rounded-[10px] tw-p-[2px]",
    handle: "tw-h-[16px] tw-w-[16px]",
    onShift: "tw-translate-x-[16px]",
  },
};

const ToggleSwitch = ({ className, on, setOn, size = "md" }: Props) => {
  const s = SIZES[size];
  return (
    <div
      className={cn(
        `tw-relative tw-flex ${s.track} tw-cursor-pointer tw-items-center tw-transition-colors ${
          on ? "tw-bg-blue-2" : "tw-bg-gray-light-0"
        }`,
        className,
      )}
      onClick={() => setOn((prevOn) => !prevOn)}
    >
      {/* OFF/ON Text on the background */}
      {size === "md" && (
        <P3B
          className={`tw-text-md tw-absolute tw-mb-0 tw-font-bold tw-text-white ${on ? "tw-left-5" : "tw-right-5"}`}
        >
          {on ? "ON" : "OFF"}
        </P3B>
      )}

      {/* The switch handle */}
      <div
        className={`${s.handle} tw-transform tw-rounded-full tw-bg-white tw-shadow-md tw-transition-transform ${
          on ? s.onShift : "tw-translate-x-0"
        }`}
      ></div>
    </div>
  );
};

export default ToggleSwitch;
